import React from 'react';
import {
  Box, Container, Divider, Paper,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Images from '../../../Configs/images';
import ROUTES from '../../../Configs/routes';

export default function Component() {
  const { t } = useTranslation();
  return (
    <Paper sx={{
      boxShadow: 'none',
      borderTop: '1px solid #E5E5E5',
      pt: 2,
    }}
    >
      <Container>
        <img src={Images.Logo} alt="logo" height="32" />
        <div className="mt-2 s-14">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </div>

        <Box mt={2}>
          <div className="weight-700">{t('footer.forClients')}</div>
          <Box mt={1}>
            <Link to="/" className="link black">Comment ça Marche</Link>
          </Box>
          <Box mt={1}>
            <Link to="/" className="link black">La Technologie</Link>
          </Box>
          <Box mt={1}>
            <Link to={ROUTES.about()} className="link black">About us</Link>
          </Box>
        </Box>

        <Box mt={2}>
          <div className="weight-700">{t('footer.wineConnect')}</div>
          <Box mt={1}>
            <Link to="/" className="link black">Pour les Passione</Link>
          </Box>
          <Box mt={1}>
            <Link to="/" className="link black">Pour les Professionels</Link>
          </Box>
        </Box>

        <Box mt={2}>
          <div className="weight-700">{t('footer.resources')}</div>
          <Box mt={1}>
            <Link to={ROUTES.contactUs()} className="link black">Contactez Nous</Link>
          </Box>
          <Box mt={1}>
            <Link to="/" className="link black">Nouvelle</Link>
          </Box>
          <Box mt={1}>
            <Link to="/" className="link black">FAQ</Link>
          </Box>
        </Box>

        <Box mt={2}>
          <div className="weight-700">
            {t('footer.follow')}
            :
          </div>
          <Box mt={1} display="flex" gap={2}>
            <Link to="/" className="link black">
              <img alt="twitter" src={Images.Twitter} />
            </Link>
            <Link to="/" className="link black">
              <img alt="facebook" src={Images.Facebook} />
            </Link>
            <Link to="/" className="link black">
              <img alt="linkedin" src={Images.Linkedin} />
            </Link>
            <Link to="/" className="link black">
              <img alt="instagram" src={Images.Instagram} />
            </Link>
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box display="flex" gap={2} justifyContent="center">
          <Link to={ROUTES.privacyPolicy()} className="link black">
            {t('profilePage.privacy')}
          </Link>
          <Link to={ROUTES.termsConditions()} className="link black">
            {t('common.tor')}
          </Link>
        </Box>

        <Box textAlign="center" my={2}>
          ©
          {' '}
          {new Date().getFullYear()}
          {' '}
          {t('footer.copy')}
        </Box>
      </Container>
    </Paper>
  );
}
